import { MessageType } from "odyssey-shared";

/**
 * The server's `harvestState` (ADR-142 decision 3, PROTOCOL.md 6.89.0) as the harvest store reads it: a hold started
 * (with the tick it ends), finished, broken or refused (each with its reason's code).
 */
export type HarvestStateEvent =
  | { readonly state: "hold"; readonly index: number; readonly endsTick: number }
  | { readonly state: "done"; readonly index: number }
  | { readonly state: "broken" | "refused"; readonly index: number; readonly reason: string };

/**
 * Reads a `harvestState`.
 *
 * @param message A parsed server message.
 * @returns The state, or null for any other message.
 * @example
 * readHarvestState({ type: MessageType.HarvestState, state: "hold", index: 4, endsTick: 4040 });
 * // { state: "hold", index: 4, endsTick: 4040 }
 */
export function readHarvestState(message: Readonly<Record<string, unknown>> & { readonly type: number }): HarvestStateEvent | null {
  if (message.type !== MessageType.HarvestState) {
    return null;
  }
  const state = message["state"] as HarvestStateEvent["state"];
  const index = message["index"] as number;
  if (state === "hold") {
    return { state, index, endsTick: message["endsTick"] as number };
  }
  if (state === "done") {
    return { state, index };
  }
  return { state, index, reason: message["reason"] as string };
}
